import { Component, inject, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  UtilityRateCardComponent
} from '@modules/settings/properties/property-configurations/utility-rate-card/utility-rate-card.component';
import { BaseLoadComponent } from '@shared/components/classes/base-load.component';
import { map, Observable } from 'rxjs';
import {
  BuildingConfiguration, GroupedUtilityRate
} from '@modules/settings/properties/property-configurations/provider-configuration.interface';
import {
  ConfigurationFormComponent
} from '@modules/settings/properties/property-configurations/configuration-form/configuration-form.component';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { ApiService } from '@shared/services/api.service';
import { ModalService } from '@shared/services/modal/modal.service';
import { ConfirmationDialogService } from '@shared/services/modal/confirm-modal.service';
import { EmptyResultComponent } from '@shared/components/empty-result/empty-result.component';
import { SkeletonModule } from '@primeng/skeleton';
import { NgCanDirective } from '@common/rbac/ng-can.directive';

@Component({
  selector: 'app-property-providers',
  standalone: true,
  imports: [
    TranslatePipe,
    UtilityRateCardComponent,
    EmptyResultComponent,
    SkeletonModule,
    NgCanDirective
  ],
  templateUrl: './property-poviders.component.html',
  styleUrl: './property-poviders.component.scss'
})
export class PropertyPovidersComponent extends BaseLoadComponent<BuildingConfiguration>{
  @Input() id: number;

  public groupedUtilityRates: GroupedUtilityRate[] = [];
  protected api = inject(ApiService);
  protected modalService = inject(ModalService);
  protected confirmModalService = inject(ConfirmationDialogService);

  getData(): Observable<BuildingConfiguration> {
    return this.api.get('utility-provider-configurations', {
      buildingId: this.id,
    }).pipe(map((res) => res.data[0] ));
  }

  afterLoadData(data: BuildingConfiguration) {
    this.groupRatesByProvider(data);
  }

  groupRatesByProvider(data: BuildingConfiguration): void {
    const groups = new Map<number, GroupedUtilityRate>();
    data.utilityRates.forEach(rate => {
      const provider = rate?.utilityProvider;
      if (provider) {
        if (!groups.has(provider.id)) {
          groups.set(provider.id, {provider: provider, rates: []});
        }
        groups.get(provider.id).rates.push(rate);
      }
    });
    this.groupedUtilityRates = Array.from(groups.values());
  }
  loadData() {
    this.groupedUtilityRates = [];
    super.loadData();
  }

  onEdit(utilityProvider: any) {
    utilityProvider.id = utilityProvider.provider.id;
    this.modalService.open({
      component: ConfigurationFormComponent,
      title: this.translateService.instant('EDIT'),
      componentOptions: {
        selectedRow: utilityProvider,
        edit: true,
        buildingId: this.id,
      },
      modalOptions: { size: "lg" }
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.loadData();
      }
    })
  }

  onDelete(utilityProvider: any) {
    this.confirmModalService.open().then((res) => {
      if (res) {
        this.api.delete(`utility-provider-configurations/${utilityProvider.provider.id}`)
          .subscribe(
            () => this.loadData(),
            (error) => this.alertErrorMessage(error?.error?.message)
          );
      }
    })
  }
}
